import BreadcrumbTitle from "components/BreadcrumbTitle"
import { SaveButton } from "components/Buttons"
import PageMetaTags from "components/PageMetaTags"
import React, { useEffect, useState } from "react"
import { connect } from "react-redux"
import { withRouter, generatePath } from "react-router-dom"
import {
  Card,
  CardBody,
  Col,
  Container,
  ListGroup,
  ListGroupItem,
  Row,
} from "reactstrap"
import {
  getQuestionnaire,
  getQuestionnaireReply,
  resetQuestionnaire,
  resetQuestionnaireReply,
} from "store/actions"
import {
  Bar,
  BarChart,
  CartesianGrid,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from "recharts"
import { TIME_FORMATS, URL_PATHS } from "constants/index"
import moment from "moment"
import ModalComponent from "components/Modals"
import UserList from "./userList"
import { EVENT_REPORTS } from "constants/url_paths"

const QuestionnaireReports = ({
  history,
  match,
  questionnaire,
  questionnaireReply,
  getQuestionnaire,
  getQuestionnaireReply,
  resetQuestionnaire,
  resetQuestionnaireReply,
  questionnaireScores,
}) => {
  const { event_id, feature_id } = match?.params
  useEffect(() => {
    getQuestionnaire({ id: feature_id })
    getQuestionnaireReply({ id: feature_id })

    return () => {
      resetQuestionnaire()
      resetQuestionnaireReply()
    }
  }, [])

  const [chartData, setChartData] = useState([])

  useEffect(() => {
    if (questionnaireReply) {
      let preparedData = []
      const results = questionnaireReply?.results
      for (const item of results) {
        let total = 0
        const responses = []
        for (const reply of item?.replies) {
          responses.push({ answer: reply?.answer, total: reply?.total })
          total += reply?.total
        }

        preparedData.push({
          question: item?.question,
          total: total,
          replies: responses,
        })
      }
      setChartData(preparedData)
    }
  }, [questionnaireReply])

  const [selectedQuestion, setSelectedQuestion] = useState(null)
  const handleBarClick = data => {
    setSelectedQuestion(data?.payload)
    setResponsesModalIsOpen(true)
  }

  const [responsesModalIsOpen, setResponsesModalIsOpen] = useState(false)

  const [individualAnswersModalIsOpen, setIndividualAnswersModalIsOpen] =
    useState(false)
  const [individualAnswer, setIndividualAnswer] = useState(null)

  const handleOpenIndividualAnswers = item => {
    setIndividualAnswersModalIsOpen(true)
    setIndividualAnswer(item)
  }

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <PageMetaTags title="Questionnaire Reports" />
          <BreadcrumbTitle
            title={questionnaire?.name || ""}
            breadcrumbItems={[
              { title: "Dashboard" },
              {
                title: "Experience Reports",
                link: generatePath(EVENT_REPORTS, { id: event_id }),
              },
              { title: "Questionnaire Report" },
            ]}
          />
          <Row className="d-flex justify-content-end mb-3">
            <Col xs="auto">
              <SaveButton
                type="button"
                color="light"
                content="Back"
                onClick={() => {
                  history.goBack()
                }}
              />
            </Col>
          </Row>
          {/* <Card>
            <CardBody>
              <Row style={{ height: "500px" }}>
                <Col>
                  <ResponsiveContainer>
                    <BarChart
                      data={chartData}
                      width={500}
                      height={500}
                      margin={{
                        top: 20,
                        right: 30,
                        left: 20,
                        bottom: 15,
                      }}
                    >
                      <CartesianGrid strokeDasharray="3 3" />
                      <XAxis
                        dataKey="question"
                        tick={{
                          stroke: "black",
                          strokeWidth: 0.5,
                        }}
                        dy={10}
                        label={{
                          value: "Questions",
                          position: "bottom",
                        }}
                      />
                      <YAxis
                        label={{
                          value: "# of Responses",
                          angle: -90,
                          position: "insideLeft",
                        }}
                        tick={{
                          stroke: "black",
                          strokeWidth: 0.5,
                        }}
                        dx={-10}
                        allowDecimals={false}
                      />
                      <Tooltip cursor={{ fill: "rgb(220, 220, 220, 0.5)" }} />
                      <Bar
                        dataKey="total"
                        name="Total responses"
                        fill="#556ee6"
                        maxBarSize={100}
                        onClick={data => {
                          handleBarClick(data)
                        }}
                      />
                    </BarChart>
                  </ResponsiveContainer>
                </Col>
              </Row>
            </CardBody>
          </Card> */}
          {!!questionnaireScores && (
            <UserList
              handleOpenIndividualAnswers={handleOpenIndividualAnswers}
              feature_id={feature_id}
              feature_name={questionnaire?.name}
            />
          )}
          <ModalComponent
            open={responsesModalIsOpen}
            onClose={() => {
              setResponsesModalIsOpen(false)
              setSelectedQuestion(null)
            }}
            size="lg"
            scrollable={true}
          >
            <Card>
              <span>
                <b>Question:</b> {selectedQuestion?.question}
              </span>

              <ListGroup className="my-3">
                <ListGroupItem>
                  <Row>
                    <Col>
                      <b>Answer</b>
                    </Col>
                    <Col>
                      <b># of Responses</b>
                    </Col>
                  </Row>
                </ListGroupItem>
                {selectedQuestion?.replies?.map((item, index) => (
                  <ListGroupItem key={index}>
                    <Row>
                      <Col>{item?.answer}</Col>
                      <Col>{item?.total}</Col>
                    </Row>
                  </ListGroupItem>
                ))}
              </ListGroup>
            </Card>
          </ModalComponent>
          <ModalComponent
            title={questionnaire?.name}
            open={individualAnswersModalIsOpen}
            onClose={() => {
              setIndividualAnswersModalIsOpen(false)
              setIndividualAnswer(null)
            }}
            size="lg"
          >
            <span>
              Viewing submission from{" "}
              <b>
                {individualAnswer?.user?.first_name +
                  " " +
                  individualAnswer?.user?.last_name}
              </b>{" "}
              on{" "}
              <b>
                {moment(individualAnswer?.created_at?.date).format(
                  TIME_FORMATS(
                    moment().diff(
                      moment(individualAnswer?.created_at?.date),
                      "days"
                    )
                  ).DATETIME
                )}
              </b>
            </span>
            <ListGroup className="my-3">
              <ListGroupItem>
                <Row>
                  <Col>
                    <b>Question</b>
                  </Col>
                  <Col>
                    <b>Answer</b>
                  </Col>
                  <Col>
                    <b>Score</b>
                  </Col>
                </Row>
              </ListGroupItem>
              {individualAnswer?.replies?.map(item => (
                <ListGroupItem key={item?.id}>
                  <Row>
                    <Col>{item?.question}</Col>
                    <Col>{item?.answer?.answer}</Col>
                    <Col>{item?.answer?.value}</Col>
                  </Row>
                </ListGroupItem>
              ))}
              <ListGroupItem>
                <Row>
                  <Col />
                  <Col>
                    <b>Total</b>
                  </Col>
                  <Col>
                    <b>{individualAnswer?.score}</b>
                  </Col>
                </Row>
              </ListGroupItem>
              <Row className="p-3">
                <Col>
                  <b>Result Title</b>
                </Col>
                <Col />
                <Col>
                  <b>{individualAnswer?.score_title}</b>
                </Col>
              </Row>
            </ListGroup>
          </ModalComponent>
        </Container>
      </div>
    </React.Fragment>
  )
}

const mapStateToProps = state => ({
  questionnaire: state.Questionnaire.questionnaire,
  questionnaireReply: state.Questionnaire.questionnaireReply,
  questionnaireScores: state.Questionnaire.questionnaireScores,
})

const mapDispatchToProps = dispatch => ({
  getQuestionnaire: values => dispatch(getQuestionnaire(values)),
  getQuestionnaireReply: values => dispatch(getQuestionnaireReply(values)),
  resetQuestionnaireReply: () => dispatch(resetQuestionnaireReply()),
  resetQuestionnaire: () => dispatch(resetQuestionnaire()),
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(QuestionnaireReports))
